import qs from "qs";
import { Core } from "Components/core";
import { initRecaptcha } from "@/components/gRecaptcha";
import { FormField } from "./field";
import { Input } from "./input";
import { Modal } from "Components/modal";
import { notification, getNotification } from "Components/notification";
import AsyncValidatorWeb from "async-validator/dist-web";

let firstFocusOnSomeForm = true;
export class Form extends Core {
  constructor(domElem) {
    super(domElem, Form.className);

    this.hasMod("has-validation") && this._setValidation();

    domElem.addEventListener("change", this._onChange.bind(this));
    domElem.addEventListener("submit", this._onSubmit.bind(this));
  }

  getFields() {
    return FormField.getInstanceCollection(
      this.domElem.querySelectorAll(`.${FormField.className}`)
    );
  }

  getVal() {
    const val = this.getFields().reduce((res, field) => {
      const name = field.getName();
      if (name) {
        res[name] = field.getVal();
      }
      return res;
    }, {});
    return val;
  }

  _setValidation() {
    var descriptor = {};
    this.getFields().forEach((field) => {
      var validate = field.getMod("validate");
      descriptor[field.getName()] = {
        type: validate === "email" ? validate : "string",
        required: field.hasMod("required"),
      };
    });
    this._validator = new AsyncValidatorWeb(descriptor);

    this._validator.messages({
      required: "Поле обязательно для заполнения",
      email: "Введите корректный адрес",
    });
  }

  _onValidationErrors(errors, fields, value) {
    this.getFields().forEach((field) => {
      const name = field.getName(),
        fieldError = fields[name];
      typeof value[name] != "undefined" && // filter Fields
        (fieldError
          ? field // вывод сообщения при ошибки
              .setValidationMessage(fieldError[0].message)
              .setMod("invalid")
          : field.delMod("invalid"));
    });
  }

  _onChange(e) {
    const target = e?.detail?.target,
      value = {};
    if (target) {
      const name =
        target instanceof Input ? target.getFieldName() : target.getName();
      const val = target.getVal();
      value[name] = val;
      this._validation(value);
    }
  }

  _validation(value) {
    this._validator &&
      this._validator.validate(value, (errors, fields) => {
        if (errors) {
          // validation failed, errors is an array of all errors
          // fields is an object keyed by field name with an array of
          // errors per field
          return this._onValidationErrors(errors, fields, value);
        } else {
          // validation passed
          this.getFields().forEach((field) => {
            field.delMod("invalid");
          });
        }
      });
  }

  _onSubmit(e) {
    e.preventDefault();

    this._validation(this.getVal());
    this.getFields().some((field) => {
      return field.hasMod("invalid");
    }) || this._sendRequest();
  }

  _closeAllModal() {
    var keys = Object.keys(Modal.instances);
    keys.forEach(function (ins) {
      if (Modal.instances[ins].domElem.classList.contains("modal_visible")) {
        Modal.instances[ins].close();
      }
    });
  }

  _sendRequest() {
    const xhr = new XMLHttpRequest(),
      domElem = this.domElem,
      data = new FormData(this.domElem);
    const method = (domElem.getAttribute("method") ?? "POST")
      .toString()
      .toUpperCase();
    let action = domElem.getAttribute("action");

    if (method === "GET") {
      const query = {};
      for (const [key, value] of data) {
        query[key] = value;
      }
      action = `${action}${action.includes("?") ? "&" : "?"}${qs.stringify(
        query
      )}`;
    }
    xhr.open(method, action);
    if (method === "GET") {
      xhr.setRequestHeader("Content-Type", "application/json");
    } else {
      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    xhr.onreadystatechange = (e) => {};
    xhr.send(method === "GET" ? null : data);

    xhr.onload = () => {
      this[xhr.status == 200 ? "_onSuccess" : "_onError"](xhr);
    };

    xhr.onerror = () => this._onError(xhr);
    this.domElem
      .querySelector(".button_type_submit")
      .classList.add("button_disabled");
  }

  _onSuccess(xhr) {
    this._closeAllModal();

    const response = JSON.parse(xhr.responseText);

    if (response.result == "success") {
      const notification = getNotification();
      this.hasMod("has-thanks") &&
        notification
          ?.setContent({
            title: response.text,
            content: response.description,
          })
          .show();

      this._emit("success", response);

      this.domElem
        .querySelector(".button_type_submit")
        .classList.remove("button_disabled");

      if (
        response.method === "redirect" &&
        response.parameters &&
        response.parameters.url
      ) {
        window.location.assign(response.parameters.url);
      }
    } else if (response.exist !== undefined) {
      this._onSerialNumberResponse(response.exist, response);
    } else {
      this._onError(xhr);
    }
  }

  _onSerialNumberResponse(exist = false, response) {
    const notification = getNotification();
    const title = "Результат проверки:";
    const text = exist
      ? "У вас оригинальное оборудование!"
      : "Оригинальность оборудования не подтверждена!<br/><br/>Обратитесь в наш сервисный центр для консультации <a href='tel:+74950218805'>+74950218805</a>";

    this.hasMod("has-thanks") &&
      notification
        ?.setContent({
          title,
          content: text,
          status: exist ? "success" : "error",
        })
        .show();

    this._emit("success", response);

    this.domElem
      .querySelector(".button_type_submit")
      .classList.remove("button_disabled");

    if (
      response?.method === "redirect" &&
      response?.parameters &&
      response.parameters?.url
    ) {
      window.location.assign(response.parameters.url);
    }
  }

  _onError(xhr) {
    const response = JSON.parse(xhr.responseText);

    if (response.exist !== undefined) {
      this._onSerialNumberResponse(response.exist, response);
    } else {
      this._closeAllModal();
      const notification = getNotification();
      console.error(`Error by form submit. Response - `, response);
      notification
        ?.setContent({
          title: response?.text ? response.text : "Ошибка",
          content: response?.description
            ? response.description
            : "При отправке произошла ошибка, обратитесь к администратору сайта или попробуйте отправить форму снова.",
        })
        .show();

      this._emit("error");

      this.domElem
        .querySelector(".button_type_submit")
        .classList.remove("button_disabled");
    }
  }

  static className = "form";
  static instances = {};

  static init() {
    document.querySelectorAll(`.${Form.className}`).forEach((formEl) => {
      formEl.addEventListener(
        "focus",
        (e) => {
          firstFocusOnSomeForm && initRecapthaOnFormFocus(firstFocusOnSomeForm);
          firstFocusOnSomeForm && (firstFocusOnSomeForm = false);
        },
        true
      );
      return new Form(formEl);
    });
  }
}

export const initRecapthaOnFormFocus = (firstFocus = false) =>
  firstFocus &&
  document.body?.classList.contains("with--recaptcha") &&
  initRecaptcha();
